import { render, staticRenderFns } from "./CampaignsPending.vue?vue&type=template&id=7715d0c6&scoped=true"
import script from "./CampaignsPending.vue?vue&type=script&lang=js"
export * from "./CampaignsPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7715d0c6",
  null
  
)

export default component.exports